import React, { useMemo, useCallback, useContext } from 'react';
import _ from 'lodash';
import cx from 'classnames';
import {
    Button,
    Tooltip,
    useModal
} from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';
import { EmailQuoteService } from 'gw-capability-quoteandbind';
import { WizardContext } from 'gw-portals-wizard-react';
import { messages as commonMessages } from 'gw-platform-translations';
import messages from './WizardSidebarButtons.messages';
import styles from './WizardSidebarButtons.module.scss';

function printQuote() {
    window.print();
}

function WizardSidebarButtons() {
    const {
        showAlert
    } = useModal();

    const translator = useTranslator();
    const wizardContext = useContext(WizardContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const { currentStep, wizardSnapshot: submissionVM } = wizardContext;

    const showEmailAddress = useCallback(() => {
        return !!_.get(submissionVM, 'baseData.accountHolder.emailAddress1.value');
    }, [submissionVM]);

    const showPrintButton = useCallback(() => {
        return _.includes(currentStep.path, 'quote');
    }, [currentStep.path]);

    const emailQuote = useCallback(() => {
        const quoteID = _.get(submissionVM, 'quoteID.value');
        const sessionUUID = _.get(submissionVM, 'sessionUUID.value');
        const emailAddress = _.get(submissionVM, 'baseData.accountHolder.emailAddress1.value');

        const emailInfo = {
            quoteID,
            sessionID: sessionUUID
        };

        EmailQuoteService.emailQuote(emailInfo)
            .then(() => {
                showAlert({
                    title: messages.saveForLater,
                    message: translator(messages.emailQuoteDescription, { quoteID, emailAddress })
                }).catch(_.noop);;
            })
            .catch(() => {
                showAlert({
                    title: messages.error,
                    message: messages.cantSendQuoteDetailsAtThisTime
                }).catch(_.noop);
            });
    }, [submissionVM, translator]);

    const shouldShowEmailButton = showEmailAddress();
    const shouldShowPrintButton = showPrintButton();

    const emailButton = useMemo(() => {
        return breakpoint === 'desktop' ? (
            <Button
                icon="envelope"
                type="secondary"
                className={styles.actionButtons}
                onClick={emailQuote}
            >
                {translator(messages.emailQuote)}
            </Button>
        ) : (
            <IconButton icon="envelope" size="large" onClick={emailQuote} />
        );
    }, [breakpoint, emailQuote, translator]);

    const printButton = useMemo(() => {
        return breakpoint === 'desktop' ? (
            <Button
                icon="print"
                type="secondary"
                onClick={printQuote}
                className={styles.actionButtons}
            >
                {translator(messages.printQuote)}
            </Button>
        ) : (
            <IconButton icon="print" size="large" onClick={printQuote} />
        );
    }, [breakpoint, translator]);

    if (!shouldShowEmailButton && !shouldShowPrintButton) {
        return null;
    }

    return (
        <div className={styles.buttonContainer}>
            {shouldShowEmailButton ? emailButton : null}
            {shouldShowPrintButton ? printButton : null}
        </div>
    );
}

export default WizardSidebarButtons;
